import { createAsyncThunk } from "@reduxjs/toolkit";
import { ActionStatus } from "../../../common/constants/action-status";
import getCookie, { COOKIE_MH_TOKEN } from "../../../common/cookies";
import { StoreState } from "../../../store/store.interface";
import { clearLoginCustomerState } from "../../customer/customer";
import { putUserProfile } from "../api/put-user-profile";
import { selectUser } from "../user-profile.selectors";
import { handleApiError, ApiError } from "../../../common/utils/api-utils";

export const validateUserPassword = createAsyncThunk(
    'userProfile/validateUserPassword',
    async (data: any, thunkAPI) => {
      try {
        const hasMHTokenCookie = getCookie(COOKIE_MH_TOKEN);
  
        if (!hasMHTokenCookie) {
          thunkAPI.dispatch(clearLoginCustomerState());
          return null;
        }
  
        const state = thunkAPI.getState() as StoreState;
        const userProfileInfo = selectUser(state);
        await putUserProfile({
          ...userProfileInfo,
          ...data,
          verifyPassword: true
        });
        return data.password;
      } catch (error) {
        console.error(error);
        if (error instanceof ApiError) {
          handleApiError(error);
        }
        return thunkAPI.rejectWithValue(error);
      }
    },
    {
      condition: (_arg, { getState }) => {
        const state = getState() as StoreState;
        return state.userProfileState.userProfileResponse.status !== ActionStatus.loading;
      },
    }
  );